import { UploadVideo } from '@chat/components/src/UploadVideo/type';
import { FAQ_TYPE } from '@/redux/faq/actionType';
import {
    PAYLOAD_INDEX_CONFIG,
    PAYLOAD_LAST,
    PAYLOAD_LOCK,
    PAYLOAD_MESSAGE,
    PAYLOAD_NOTICE,
    PAYLOAD_START_SESSION,
    PAYLOAD_STATUS,
    PAYLOAD_WAKEUP
} from '@/typings/payload';
import { ActionModify, ImState } from '@/typings/reducer';
import { IM_LOCAL_VIDEO_FILE, IM_USER_CONTACT } from '@/typings/global';

export enum IM_TYPE {
    // 设置人工基本信息
    SET_SESSION = 'SET_SESSION',
    // 阶段转换标记
    SET_START_SESSION = 'SET_START_SESSION',
    // 插入消息
    SET_MESSAGE_LIST = 'SET_MESSAGE_LIST',
    // 插入通知
    SET_NOTICE_LIST = 'SET_NOTICE_LIST',
    // 设置最后条的id和时间及超时标记
    SET_LAST = 'SET_LAST',
    // 唤醒对话
    SET_WAKEUP_CHAT = 'SET_WAKEUP_CHAT',
    // 设置会话各阶段状态
    SET_CHAT_STATUS = 'SET_CHAT_STATUS',
    // 重新发送消息
    RESEND_MESSAGE = 'RESEND_MESSAGE',
    // 问题计数
    SET_MESSAGE_COUNT = 'SET_MESSAGE_COUNT',
    // 重制会话相关数据
    RELOAD_IM = 'RELOAD_IM',
    // 改变阶段状态
    SET_STAGE_STATUS = 'SET_STAGE_STATUS',
    // 导航条开关
    SET_NAV_VISIBLE = 'SET_NAV_VISIBLE',
    // 注入配置参数
    SET_INDEX_CONFIG = 'SET_INDEX_CONFIG',
    // 重制数据
    SET_DEFAULT_STATE = 'SET_DEFAULT_STATE',

    // 设置锁定状态
    SET_LOCK_STATUS = 'SET_LOCK_STATUS',
    // 视频锁
    SET_VIDEO_LOCK = 'SET_VIDEO_LOCK',
    // 视频对象
    SET_VIDEO_PARAM = 'SET_VIDEO_PARAM',
    // 缓存视频到临时列表
    SET_VIDEO_TEMP_LIST = 'SET_VIDEO_TEMP_LIST',
    // 同步本地视频消息uuid
    SET_VIDEO_MESSAGE_UUID = 'SET_VIDEO_MESSAGE_UUID',

    // 设置用户联系方式
    SET_USER_CONTACT = 'SET_USER_CONTACT'
}

export interface IMSetSessionAction {
    type: IM_TYPE.SET_SESSION;
    payload: ImState;
}
export interface IMSetStartSessionAction {
    type: IM_TYPE.SET_START_SESSION;
    payload: PAYLOAD_START_SESSION;
}
export interface IMSetFaqMessageAction {
    type: FAQ_TYPE.SET_FAQ_MESSAGE;
    payload: PAYLOAD_MESSAGE;
}
export interface IMUpdateFaqServerContentAction {
    type: FAQ_TYPE.UPDATE_FAQ_SERVER_CONTENT;
    payload: {
        id: number | string;
        content: string;
    };
}
export interface IMRemoveFaqLoadingAction {
    type: FAQ_TYPE.REMOVE_FAQ_LOADING;
    payload?: never;
}
export interface IMSetMessageAction {
    type: IM_TYPE.SET_MESSAGE_LIST;
    payload: PAYLOAD_MESSAGE;
}
export interface IMSetNoticeAction {
    type: IM_TYPE.SET_NOTICE_LIST;
    payload: PAYLOAD_NOTICE;
}
export interface IMSetLastAction {
    type: IM_TYPE.SET_LAST;
    payload: PAYLOAD_LAST;
}
export interface IMSetWakeUpAction {
    type: IM_TYPE.SET_WAKEUP_CHAT;
    payload: PAYLOAD_WAKEUP;
}
export interface IMSetChatStatusAction {
    type: IM_TYPE.SET_CHAT_STATUS;
    payload: PAYLOAD_STATUS;
}
export interface IMResendMessageAction {
    type: IM_TYPE.RESEND_MESSAGE;
    payload: string;
}
export interface IMSetMessageCountAction {
    type: IM_TYPE.SET_MESSAGE_COUNT;
    payload?: never;
}
export interface IMReloadImAction {
    type: IM_TYPE.RELOAD_IM;
    payload?: never;
}
export interface IMSetStageStatusAction {
    type: IM_TYPE.SET_STAGE_STATUS;
    payload: ImState['stage'];
}
export interface IMSetNavVisibleAction {
    type: IM_TYPE.SET_NAV_VISIBLE;
    payload: number;
}
export interface IMSetIndexConfigAction {
    type: IM_TYPE.SET_INDEX_CONFIG;
    payload: PAYLOAD_INDEX_CONFIG;
}
export interface IMSetDefaultStateAction {
    type: IM_TYPE.SET_DEFAULT_STATE;
    payload: never;
}
export interface IMSetLockStatusAction {
    type: IM_TYPE.SET_LOCK_STATUS;
    payload: PAYLOAD_LOCK;
}
export interface IMSetVideoLockStateAction {
    type: IM_TYPE.SET_VIDEO_LOCK;
    payload: boolean;
}
export interface IMSetVideoParamStateAction {
    type: IM_TYPE.SET_VIDEO_PARAM;
    payload: UploadVideo;
}
export interface IMSetVideoTempListStateAction {
    type: IM_TYPE.SET_VIDEO_TEMP_LIST;
    payload: string;
}
export interface IMSetVideoMessageUuidStateAction {
    type: IM_TYPE.SET_VIDEO_MESSAGE_UUID;
    payload: {
        file: IM_LOCAL_VIDEO_FILE;
        uuid: string;
    };
}
export interface IMSetUserContactStateAction {
    type: IM_TYPE.SET_USER_CONTACT;
    payload: IM_USER_CONTACT;
}
export type IMModifyAction =
    | ActionModify<IMSetSessionAction, ImState>
    | ActionModify<IMSetStartSessionAction, ImState>
    | ActionModify<IMSetFaqMessageAction, ImState>
    | ActionModify<IMUpdateFaqServerContentAction, ImState>
    | ActionModify<IMSetMessageAction, ImState>
    | ActionModify<IMSetNoticeAction, ImState>
    | ActionModify<IMSetLastAction, ImState>
    | ActionModify<IMSetWakeUpAction, ImState>
    | ActionModify<IMSetChatStatusAction, ImState>
    | ActionModify<IMResendMessageAction, ImState>
    | ActionModify<IMSetMessageCountAction, ImState>
    | ActionModify<IMReloadImAction, ImState>
    | ActionModify<IMSetStageStatusAction, ImState>
    | ActionModify<IMSetNavVisibleAction, ImState>
    | ActionModify<IMSetIndexConfigAction, ImState>
    | ActionModify<IMSetDefaultStateAction, ImState>
    | ActionModify<IMSetLockStatusAction, ImState>
    | ActionModify<IMSetVideoLockStateAction, ImState>
    | ActionModify<IMSetVideoParamStateAction, ImState>
    | ActionModify<IMSetVideoTempListStateAction, ImState>
    | ActionModify<IMSetVideoMessageUuidStateAction, ImState>
    | ActionModify<IMSetUserContactStateAction, ImState>
    | ActionModify<IMRemoveFaqLoadingAction, ImState>;
export type IMModifyType = IM_TYPE;
